import { motion } from "framer-motion";
import { Instagram } from "lucide-react";

const SOCIALS = [
  {
    name: "TikTok",
    handle: "@slhphone69",
    url: "https://www.tiktok.com/@slhphone69",
    desc: "Coulisses des réparations et avant/après en vidéo",
    buttonClass: "bg-zinc-950 text-white hover:bg-zinc-800",
    testId: "social-tiktok",
  },
  {
    name: "Instagram",
    handle: "@slhphone69",
    url: "https://www.instagram.com/slhphone69",
    desc: "Photos de réparations et actualités",
    buttonClass: "bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737] text-white hover:opacity-90",
    testId: "social-instagram",
  },
  {
    name: "Snapchat",
    handle: "slhphone69",
    url: "https://www.snapchat.com/add/slhphone69",
    desc: "Les interventions en direct, au quotidien",
    buttonClass: "bg-[#FFFC00] text-zinc-950 hover:bg-[#f5ef00]",
    testId: "social-snapchat",
  },
];

export const TikTokIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

export const SnapchatIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.504-.104.329 0 .656.15.835.42.163.239.148.539-.016.765-.195.286-.594.554-1.063.809a5.696 5.696 0 0 1-.615.254c-.227.076-.538.181-.706.33-.119.104-.157.27-.104.553l.016.075c.07.359.854 2.204 2.835 3.313.235.132.464.254.696.364.823.39.744.649.704.914-.061.373-.54.479-1.063.591-.557.118-1.18.25-1.596.433-.151.285-.254.871-.27 1.04-.014.166-.146.354-.357.379-.36.044-1.1-.102-1.741.011-.119.02-.256.058-.362.103-.495.208-1.082.608-1.671 1.105-.795.674-1.707 1.026-2.647 1.026-.362 0-.717-.075-1.055-.231l-.101-.044a3.83 3.83 0 0 0-.637-.253 4.204 4.204 0 0 0-.855-.085c-.316 0-.612.024-.854.085-.149.041-.428.14-.638.254-.18.088-.524.183-1.156.231-.988.075-1.864-.412-2.544-1.03-.629-.601-1.341-.996-1.808-1.181-.101-.042-.227-.083-.343-.102-.605-.105-1.261.044-1.717-.011-.123-.015-.293-.153-.344-.36a2.98 2.98 0 0 0-.255-1.025c-.445-.195-1.137-.328-1.596-.43-.555-.119-.983-.225-1.044-.596-.045-.267-.164-.535.705-.928.225-.104.449-.22.672-.344 1.99-1.113 2.777-2.966 2.846-3.324l.016-.074c.053-.285.016-.449-.102-.552-.169-.15-.481-.255-.708-.331a5.61 5.61 0 0 1-.613-.254c-.474-.255-.871-.523-1.067-.81-.163-.225-.178-.525-.016-.764.18-.27.507-.42.836-.42.16 0 .34.016.504.104.374.181.734.285 1.033.3.198 0 .326-.044.4-.089l-.046-.569c-.104-1.627-.227-3.653.306-4.847C7.673 1.07 11.018.793 12.008.793h.198z" />
  </svg>
);

const SocialIcon = ({ name }) => {
  if (name === "TikTok") return <TikTokIcon />;
  if (name === "Instagram") return <Instagram className="h-5 w-5" strokeWidth={2} />;
  return <SnapchatIcon />;
};

export const TikTok = () => {
  return (
    <section id="tiktok" className="relative py-28 lg:py-36 border-t border-zinc-200 overflow-hidden" data-testid="tiktok-section">
      <div
        className="pointer-events-none absolute -top-24 left-1/3 h-[360px] w-[360px] rounded-full bg-[#0055FF] opacity-[0.08] blur-[130px]"
        aria-hidden="true"
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p
          className="text-xs uppercase tracking-[0.35em] text-[#0055FF] mb-6"
        >
          Réseaux sociaux
        </motion.p>
        <motion.h2
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight uppercase text-zinc-950 mb-6"
        >
          Suivez<span className="text-chrome">-nous</span>
        </motion.h2>
        <motion.p
          className="max-w-xl text-base md:text-lg font-light leading-relaxed text-zinc-600 mb-14"
        >
          Coulisses des réparations, avant/après et conseils d'entretien :
          retrouvez SLH PHONE en vidéo et en photo sur vos réseaux préférés.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {SOCIALS.map((social) => (
            <motion.a
              key={social.name}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col justify-between border border-zinc-200 bg-white p-8 hover:border-[#0055FF]/60 hover:bg-[#0055FF]/5 transition-colors duration-400"
              data-testid={social.testId}
              aria-label={`Suivre SLH PHONE sur ${social.name}`}
            >
              <p className="text-sm font-light leading-relaxed text-zinc-600 mb-10">
                {social.desc}
              </p>
              <div
                className={`flex items-center justify-center gap-3 rounded-full px-6 py-4 text-sm font-semibold uppercase tracking-[0.15em] transition-all duration-300 ${social.buttonClass}`}
              >
                <SocialIcon name={social.name} />
                {social.handle}
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
